import { post, get } from "@/utils/utils";

const operatingPlan = {
  state: {},
  mutations: {
    QUERY_PHYSIOLIGICAL_LIST() {},
    PHYSIOLIGICAL_INFO() {},
    PHYSIOLIGICAL_OVERVIEW_LIST() {},
    PHYSIOLIGICAL_BEHAVIOR_LIST() {},
    QUERY_PHYSIOLIGICAL_INTEREST_LIST() {},
    QUERY_RECOMMEND_RULE_CONFIG() {},
    QUERY_RECOMMEND_RULE_CONFIG_INFO() {},
    QUERY_PHYSIOLIGICAL_MEMBER_RANGE_LIST() {},
    QUERY_PHYSIOLIGICAL_MEMBER_RANGE_DETAILS() {},
    QUERY_PHYSIOLIGICAL_AXIS_GOODS_LIST() {},
    QUERY_AGE_GROP_PLAN_LIST() {},
    QUERY_AGE_GROP_DISTRIBUTION() {},
    QUERY_MEMBER_RANGE_DETAILS_LIST() {},
    QUERY_PHYSIOLIGICAL_TAG_LIST() {},
    QUERY_MEMBER_RANGE_DETAILS_ALL_LIST() {}
  },
  actions: {
    queryPhysiologicalList({ commit }, params) {
      return post({
        commit,
        url: `/physiological/axis/back/table_name/list`,
        name: "QUERY_PHYSIOLIGICAL_LIST",
        params
      });
    },
    physiologicalInfo({ commit }, params) {
      return post({
        commit,
        url: `/physiological/axis/back/index`,
        name: "PHYSIOLIGICAL_INFO",
        params
      });
    },
    physiologicalOverviewList({ commit }, params) {
      return post({
        commit,
        url: `/physiological/axis/back/overview`,
        name: "PHYSIOLIGICAL_OVERVIEW_LIST",
        params
      });
    },
    physiologicalBehaviorList({ commit }, params) {
      return post({
        commit,
        url: `/physiological/axis/back/behavior/info`,
        name: "PHYSIOLIGICAL_BEHAVIOR_LIST",
        params
      });
    },
    queryPhysiologicalInterestList({ commit }, params) {
      return post({
        commit,
        url: `/physiological/axis/back/goods/interests`,
        name: "QUERY_PHYSIOLIGICAL_INTEREST_LIST",
        params
      });
    },
    queryRecommendRuleConfig({ commit }, params) {
      return post({
        commit,
        url: `/physiological/axis/back/recommend_rule/config`,
        name: "QUERY_RECOMMEND_RULE_CONFIG",
        params
      });
    },
    queryRecommendRuleConfigInfo({ commit }, params) {
      return post({
        commit,
        url: `/physiological/axis/back/recommend_rule/config_info`,
        name: "QUERY_RECOMMEND_RULE_CONFIG_INFO",
        params
      });
    },
    queryPhysiologicalMemberRangeList({ commit }, params) {
      return post({
        commit,
        url: `/physiological/axis/back/member_range/list`,
        name: "QUERY_PHYSIOLIGICAL_MEMBER_RANGE_LIST",
        params
      });
    },
    queryPhysiologicalMemberRangeDetail({ commit }, params) {
      return post({
        commit,
        url: `/physiological/axis/back/member_range/detail`,
        name: "QUERY_PHYSIOLIGICAL_MEMBER_RANGE_DETAILS",
        params
      });
    },
    queryPhysiologicalAxisGoodsList({ commit }, params) {
      return post({
        commit,
        url: `/physiological/axis/back/goods/list`,
        name: "QUERY_PHYSIOLIGICAL_AXIS_GOODS_LIST",
        params
      });
    },
    queryAgeGroupPlanInfoPageList({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/queryAgeGroupPlanInfoPageList`,
        name: "QUERY_AGE_GROP_PLAN_LIST",
        params
      });
    },
    queryAgeGroupDistribution({ commit }, params) {
      return post({
        commit,
        url: `/physiological/axis/back/age_group/number_distribution`,
        name: "QUERY_AGE_GROP_DISTRIBUTION",
        params
      });
    },
    queryMemberRangeDetailList({ commit }, params) {
      return post({
        commit,
        url: `/physiological/axis/back/member_range/detail_list`,
        name: "QUERY_MEMBER_RANGE_DETAILS_LIST",
        params
      });
    },
    queryMemberRangeDetailAllList({ commit }, params) {
      return post({
        commit,
        url: `/physiological/axis/back/member_range/detail_list`,
        name: "QUERY_MEMBER_RANGE_DETAILS_ALL_LIST",
        params
      });
    },
    queryPhysiologicalTagList({ commit }, params) {
      return post({
        commit,
        url: `/physiological/axis/back/goods_tag/list?pageSize=${params.pageSize}&pageNo=${params.pageNo}&tagName=${params.tagName}`,
        name: "QUERY_PHYSIOLIGICAL_TAG_LIST",
        params
      });
    }
  }
};
export default operatingPlan;
